export default __webpack_public_path__ + "static/media/rugs.a74b97cb.jpg";